// Copyright (c) Move Closer 2022.

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const searchResultsConfig = {
  searchFromChars: 3
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const SEARCH_RESULTS_COMPONENT_KEY = 'SearchResultsComponent'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const DEFAULT_COMPONENT_CONFIG = {
  calculateOffsetForNavbar: false,
  searchInputClosable: true,
  searchInputOpenOnStart: false,
  searchInputHasButton: false,
  hasCloseIcon: true,
  hasSearchHints: true,
  shouldRelyOnIsOpen: false,
  shouldSetResultsPosition: false,
  shouldWatchResize: false,
  sliceResults: 0
}
